import type { TopicText, TopicInline } from "../../data/study/topics/types";
import { isDutchPhrase } from "@a2/i18n/helpers";

export function InlineText({ text }: { text: TopicText }) {
  const parts: TopicInline[] = typeof text === "string" ? [text] : text;
  return (
    <>
      {parts.map((p, i) =>
        isDutchPhrase(p) ? (
          <span
            key={i}
            className="text-[var(--ink)] underline decoration-dashed decoration-[var(--accent-soft)] underline-offset-4"
            lang="nl"
          >
            {p.text}
          </span>
        ) : (
          <span key={i}>{p}</span>
        ),
      )}
    </>
  );
}
